import NotificationsFeed from '@components/notifications/notifications-feed/notifications-feed.component'
import { useTranslation } from 'react-i18next'
import './notifications.page.scoped.scss'

const NotificationsPageComponent = (props: any) => {
  const [t] = useTranslation('globalMain')
  return (
    <div className="notifications-page box">
      <h1 className="display-flex justify-content-space-between align-items-center">{t('notifications')}</h1>
      <NotificationsFeed />
    </div>
  )
}
export default NotificationsPageComponent
